import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
import TextBanner from "../components/text_banner"

import boy_icon from "../assets/images/boy.svg"
import teen_icon from "../assets/images/teen.svg"
import teenage_icon from "../assets/images/teenage.svg"
import aunt_icon from "../assets/images/aunt.svg"
import couples_icon from "../assets/images/Couples.svg"
import relationships_icon from "../assets/images/relationships.svg"
import stress_icon from "../assets/images/stress.svg"
import anxiety_icon from "../assets/images/anxiety.svg"
import depression_icon from "../assets/images/depression.svg"
import fear_icon from "../assets/images/fear.svg"
import trauma_icon from "../assets/images/trauma.svg"
import loneliness_icon from "../assets/images/loneliness.svg"
import chronic_icon from "../assets/images/Chronic.svg"
import grief_icon from "../assets/images/grief.svg"
import anger_icon from "../assets/images/Anger.svg"
import child_icon from "../assets/images/child.svg"
import procrastination_icon from "../assets/images/Procrastination.svg"
import authenticity_icon from "../assets/images/authenticity.svg"
import communication_icon from "../assets/images/communication.svg"
import insecurity_icon from "../assets/images/insecurity.svg"
import self_esteem_icon from "../assets/images/self-esteem.svg"
import body_image_icon from "../assets/images/body-image.svg"
import fat_icon from "../assets/images/fat.svg"
import eating_icon from "../assets/images/Eating.svg"

function Services() {
  return (
    <Layout>
      <Helmet>
        <title>InTouch Counselling Services - Services</title>
      </Helmet>

      <TextBanner
        h1="My Services"
      ></TextBanner>

<section id="wrapper">
      <section id="one" className="wrapper spotlight style1">
        <div className="inner">
          <div className="about-content">
            <h2>My practice includes working with the following:
            </h2>
            <div className="my-modalities">
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={boy_icon}/>
                  </div>
                  <p>Children
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={teen_icon}/>
                  </div>
                  <p>Young Adults
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={teenage_icon}/>
                  </div>
                  <p>Teens
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={aunt_icon}/>
                  </div>
                  <p>Adults
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={couples_icon}/>
                  </div>
                  <p>
                    Couples
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={relationships_icon}/>
                  </div>
                  <p>Family
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={stress_icon}/>
                  </div>
                  <p>Stress
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={anxiety_icon}/>
                  </div>
                  <p>Anxiety & Panic Attacks
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={depression_icon}/>
                  </div>
                  <p>Depression
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={fear_icon}/>
                  </div>
                  <p>Fear
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={trauma_icon}/>
                  </div>
                  <p>Trauma
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={loneliness_icon}/>
                  </div>
                  <p>Loneliness & Isolation
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={chronic_icon}/>
                  </div>
                  <p>Chronic pain
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={grief_icon}/>
                  </div>
                  <p>
                    Loss & grief
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={anger_icon}/>
                  </div>
                  <p>
                    Anger Management
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={child_icon}/>
                  </div>
                  <p>
                    Inner Child Work
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={procrastination_icon}/>
                  </div>
                  <p>
                    Procrastination & Perfection
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={authenticity_icon}/>
                  </div>
                  <p>Goal Setting
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={communication_icon}/>
                  </div>
                  <p>
                    Effective Communication
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={insecurity_icon}/>
                  </div>
                  <p>Self Esteem & Self-confidence
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={self_esteem_icon}/>
                  </div>
                  <p>Self Love & Acceptance
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={body_image_icon}/>
                  </div>
                  <p>Body Image
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={fat_icon}/>
                  </div>
                  <p>Obesity & Emotional Eating
                  </p>
                </div>
              </div>
              <div>
                <div className="item">
                  <div className="icon">
                    <img alt="" src={eating_icon}/>
                  </div>
                  <p>Compulsive & Habitual Eating
                  </p>
                </div>
              </div>
            </div>
            <br /> <br />
            <br />
          </div>
        </div>
      </section>
    </section>

    </Layout>
  )
}

export default Services
